import PageLayout from "../../components/layout/page";
import LedgerList from "./client";

export default function LeadgerReport() {
  return (
    <PageLayout className="dashboard-inner-page"
      View={
        <>
          <LedgerList />
        </>
      }
    />
  );
}